import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/404',
  alias: '*',
  name: 'PaginaNaoEncontrada',
  component: function component() {
    return import(/* webpackChunkName: "publico" */'./pages/PaginaNaoEncontrada');
  },
  meta: {
    titulo: 'Página não encontrada',
    precisaAutenticacao: false,
    cabecalho: false,
    rodape: true,
    btnHelp: false
  }
}];